<template>
  <div class="chat-warp" @click="msgOptionState = false" @click.right="chatRightClick">
    <div class="chat-title">
      相亲相爱一家人
    </div>
    <div ref="mianscroll" class="chat-cont">
      <div class="msg-line">
        <div class="msg-over">没有更多消息了</div>
      </div>
      <div class="msg-line msg-line-from">
        <img alt="" class="msg-nick" src="../../assets/img/test1.jpg">
        <div class="msg-cont">
          <div class="msg-cont-name">吴佳丽</div>
          <div class="msg-cont-word">欢迎使用云信IM UIkit，现在就发送属于你的第一条消息吧~</div>
          <div class="msg-cont-time">09-07 16:12:29</div>
        </div>
      </div>

      <template  v-for="item in chatList">
        <ChatMessage @rightClick="showMsgOption" :message="item" :from-user="fromUser" :to-user="toUser" />
      </template>

    </div>
    <div class="chat-bottom">
      <div class="chat-bottom-in">
        <el-input
            v-model="msg"
            :autosize="{ minRows: 1, maxRows: 4}"
            class="chat-in-msg" placeholder="按enter直接发送，shift+enter换行" type="textarea" @keydown.native="keyDown"></el-input>
        <div class="chat-option">
          <el-popover
              offset=30
              placement="bottom"
              trigger="click"
              width="274">
            <div class="emoji-warp">
              <div v-for="item in emoji" :class="item.icon" class="iconemoji" @click="emojiIn(item.name)"></div>
            </div>
            <el-button slot="reference" size="small">表</el-button>
          </el-popover>
          <div class="chat-in-other">
            <input id="msgImg" :multiple="false" accept="image/*" type="file" @change="handleImgChange">
          </div>
          <div class="chat-in-other">
            <input id="msgFile" type="file" @change="handleFileChange">
          </div>


          <el-button @click="sendMsg">发送</el-button>
        </div>
      </div>
    </div>

    <div :style="{'left':msgOptionPosition[0] + 'px','top':msgOptionPosition[1] + 'px'}" v-if="msgOptionState" class="msg-option">
        <div @click="openModel('del')">删除</div>
        <div>撤回</div>
    </div>


<!--    <Sign/>-->

  </div>
</template>

<script>
import emoji from "@/utils/emoji";
import ChatMessage from "@/views/chat/ChatMessage";
import Sign from '@/components/Sign'

export default {
  components:{ChatMessage,Sign},
  data() {
    return {
      nim: null,
      initFinish: false,
      msg: '',
      emoji,
      chatList: [],
      fromUser:'test2',
      toUser:'test',
      msgOptionState:false,
      msgOptionPosition:[],
      msgOptionInfo:[]
    }
  },
  onShow() {
    if (this.initFinish) this.getMsg()

  },
  mounted() {
    this.initIM()




  },
  methods: {
    initIM() {
      let _that = this
      this.$nextTick(() => {
        this.nim = this.NIM.getInstance({
          debug: false,   // 是否开启日志，将其打印到console。集成开发阶段建议打开。
          appKey: '7f04e1c69a70c76abe78563ce9831a39',
          account: this.fromUser,//用于登录IM
          token: '123456',//用于登录IM
          db: false, //若不要开启数据库请设置false。SDK 默认为true。
          autoMarkRead: true, // 开启自动标记消息已读
          syncSessionUnread: true, // 同步会话的未读数,
          onconnect: _that.onConnect,
          onofflinemsgs: _that.onOfflineMsgs,// 初始化同步时，用于接收离线消息的回调函数
          onmsg: _that.onMsg, // 用户在线或多端同步时，用于接收消息的回调函数（实时消息）
          onsessions: _that.onSessions, // 初始化同步时，用于获取会话列表的回调函数
          onsyncdone: function () {
            _that.initFinish = true
            _that.getMsg()
          } // 同步完成
        });
      })

    },
    onOfflineMsgs(msg) {
      console.log('--------------------msg')
      console.log(msg)
    },
    onConnect(msg) {
      console.log('收到消息onConnect', msg);
    },
    onMsg(msg) {
      console.log('收到消息', msg.scene, msg.type, msg);
    },
    onSessions(msg) {
      console.log('收到消息onSessions', msg);
      // this.chatList = msg
    },
    keyDown(e) {
      if (!e.shiftKey && e.keyCode == 13) {
        e.cancelBubble = true;
        e.stopPropagation();
        e.preventDefault();
        this.sendMsg()
      }
    },
    sendMsg() {
      var _that = this
      this.nim.sendText({
        scene: 'p2p',
        to: this.toUser,
        text: this.msg,
        done:(error, msg) =>{
          _that.msg = ''
          _that.chatList = _that.chatList.concat(msg)
          _that.bottomScrollClick()
          console.log(msg)
          console.log('发送' + msg.scene + ' ' + msg.type + '消息' + (!error ? '成功' : '失败') + ', id=' + msg.idClient);
        }
      });
    },
    sendMsgDone(error, msg) {

    },
    getMsg() {
      this.nim.getHistoryMsgs({
        asc: true,
        limit: 20,
        scene: 'p2p',
        to: this.toUser,
        done: (error, msg) => {
          this.chatList = msg.msgs
          this.bottomScrollClick()
        }
      })
    },
    emojiIn(name) {
      this.msg = this.msg + name
    },

    bottomScrollClick() {
      this.$nextTick(() => {
        let scrollEl = this.$refs.mianscroll;
        scrollEl.scrollTo({top: scrollEl.scrollHeight, behavior: 'smooth'});
      });
    },
    handleImgChange(e) {
      var _that = this
      console.log(e.target.files[0])
      this.nim.sendFile({
        scene: 'p2p',
        to: this.toUser,
        type: 'image',
        fileInput: 'msgImg',
        done: function (err, obj) {
          if (err) {
            console.log('发送失败', err)
            // 重发. 当上传文件失败时 obj 参数的 msg 附带消息体，其他情况的 obj 就是消息体。
            setTimeout(function () {
              this.resendMessage(obj.msg ? obj.msg : obj,'msgImg','image')
            }, 3000)
          } else {
            console.log('发送消息成功，消息为: ', obj)
            _that.chatList = _that.chatList.concat(obj)
            _that.bottomScrollClick()
          }
        }
      })
    },
    handleFileChange(e){
      console.log('eeeeeeeeeeeeeeee')
      console.log(e)
      var _that = this
      this.nim.sendFile({
        scene: 'p2p',
        to: this.toUser,
        type: 'file',
        fileInput: 'msgFile',
        done: function (err, obj) {
          if (err) {
            console.log('发送失败', err)
            // 重发. 当上传文件失败时 obj 参数的 msg 附带消息体，其他情况的 obj 就是消息体。
            setTimeout(function () {
              this.resendMessage(obj.msg ? obj.msg : obj,'msgFile','file')
            }, 3000)
          } else {
            console.log('发送消息成功，消息为file: ', obj)
            _that.chatList = _that.chatList.concat(obj)
            _that.bottomScrollClick()
          }
        }
      })
    },
    resendMessage(oldMessage,domId,fileType) {
      this.nim.sendFile(Object.assign(oldMessage, {
        scene: 'p2p',
        to: this.toUser,
        type: fileType,
        fileInput: domId,
        resend: true, // 注意这个 resend 标记为 true，才能固定使用 oldMessage 里的 idClient
        done: function (err, obj) {
          if (err) {
            console.log('发送失败', err)
          } else {
            console.log('发送消息成功，消息为: ', obj)
          }
        }
      }))
    },
    showMsgOption(addr,info){
      this.msgOptionInfo = info
      this.msgOptionState = !this.msgOptionState
      this.msgOptionPosition = addr
      console.log(info)
    },
    chatRightClick(e){
      e.preventDefault()
    },
    openModel(type){
      console.log(this.msgOptionInfo)
      this.nim.deleteMsgSelf({
        msg:this.msgOptionInfo,
        done:function (err,obj) {
          console.log(err)
          console.log(obj)
        }
      })
    }
  }
}
</script>

<style src="../../assets/css/chat.css">

</style>
